
<div
  v-if="items"
  class="ws-checkbox-list"
>
  <div class="flex-md">
    <div
      v-for="(column, i) of itemsFilteredSplitedColumns"
      :key="`itemsColumn-${i}`"
      :class="
        `ws-checkbox-col col q-col-gutter-md col-equal col-${12 / columns}`
      "
    >
      <div
        v-for="(item, index) in column"
        :key="get(item, uidProp, JSON.stringify(item)) + '_item_' + index"
        class="ws-checkbox-item"
        :class="{ disabled: get(item, 'disable') }"
      >
        <ws-checkbox
          v-model="valueData[item[uidProp]]"
          large
          full-width
          class="ws-hover-fly-in-trigger"
          :class="{
            selected: valueData[item[uidProp]] === true || showSelectedOnly,
          }"
          :disable="get(item, 'disable') || !inEdit"
          @input="$emit('input', { ...valueData })"
        >
          <slot
            :item="item"
            :is-selected="valueData[item[uidProp]] === true || showSelectedOnly"
          ></slot>
        </ws-checkbox>
        <div class="info">
          <slot
            name="info"
            :item="item"
            :is-selected="valueData[item[uidProp]] === true || showSelectedOnly"
          ></slot>
        </div>
      </div>
    </div>
  </div>
  <slot name="extra"></slot>
</div>
